/**
 * Do not edit directly
 * Generated on Wed, 27 May 2026 03:47:48 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
